// extracted by mini-css-extract-plugin
export default {"PaymentServices":"-Umbi","caption":"akb6g","icons":"_9Pvfo","skeleton-progress":"vC-F9"};